import { connect } from 'react-redux'
import React from 'react'
import Roles from '../models/Roles'
import PlayerPage from '../components/PlayerPage'
import HostPage from '../containers/HostPage'
import Login from '../containers/Login'
import ImproviserPage from './ImproviserPage'

class MainPage extends React.Component  {
    state = {
        isLogged : false, 
    }

    componentDidMount(){
        this.setState({isLogged:this.props.user.isLogged});
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user)
        this.setState({isLogged:this.props.user.isLogged});
    }

    render(){
        const {user,socket} = this.props;
        const {roles} = user
        const {isLogged} = this.state
        const isPlayer = roles==Roles.PLAYER
        const isHost = roles==Roles.HOST
        const isImproviser = roles==Roles.IMPROVISER
    
        if (!isLogged){
                return (
                <div style={{ minHeight: '100%', position: 'relative' }}>
                    <Login socket={socket} />
                </div>
                )
        }
        if (isPlayer){
            return <PlayerPage socket={socket} isLogged={isLogged} user={user}/>
        }
        if (isImproviser)
            return <ImproviserPage socket={socket}/>
            
         if (isHost)
           return <HostPage socket={socket}/>
        return <div>Non hai nessun ruolo</div>
    }
    
   
}

const mapStateToProps = state => ({
    socket: state.socket,
    user: state.user,
})

const mapDispatchToProps = (dispatch, {socket}) => ({
})


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MainPage)


// WEBPACK FOOTER //
// ./src/components/MainPage.js